import {
  AlignLeftIcon,
  CalendarIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  CurrencyDollarIcon,
  Hash01Icon,
  ListIcon,
  Mail01Icon,
  PenTool01Icon,
  PhoneIcon,
  Star01Icon,
  Target05Icon,
  Type01Icon,
  Upload01Icon,
} from "@gohighlevel/ghl-icons/24/outline";
import type { Component } from "vue";

const ICON_BY_DATA_TYPE: Record<string, Component> = {
  TEXT: Type01Icon,
  STANDARD_FIELD: Type01Icon,
  NUMERICAL: Hash01Icon,
  SCORE: Hash01Icon,
  MONETORY: CurrencyDollarIcon,
  LARGE_TEXT: AlignLeftIcon,
  SINGLE_OPTIONS: ChevronDownIcon,
  MULTIPLE_OPTIONS: ChevronDownIcon,
  CHECKBOX: CheckSquareIcon,
  RADIO: Target05Icon,
  DATE: CalendarIcon,
  FILE_UPLOAD: Upload01Icon,
  SIGNATURE: PenTool01Icon,
  TEXTBOX_LIST: ListIcon,
  PHONE: PhoneIcon,
  EMAIL: Mail01Icon,
  RATING: Star01Icon,
};

export function getFieldTypeIcon(dataType: string | undefined | null): Component {
  if (!dataType) {
    return Type01Icon;
  }
  return ICON_BY_DATA_TYPE[dataType] ?? Type01Icon;
}
